import upperFirst from 'lodash/upperFirst'

import {
  TASTE_PROFILE_GA_EVENT,
  TASTE_PROFILE_GA_FILTER_EVENT,
  GTM_CLICK_TRACKING_PROP_NAME,
  GTM_IMPRESSION_TRACKING_PROP_NAME
} from 'constants/global'

export const createTasteProfileEvent = (eventAction, eventLabel = '', nonInteraction = false) => {
  const event = Object.assign({}, TASTE_PROFILE_GA_EVENT, {
    eventAction,
    eventLabel
  })
  if (nonInteraction) {
    event.nonInteraction = nonInteraction
  }

  return event
}

export const trackTasteProfileEvent = (eventAction, eventLabel = '', nonInteraction = false) => ({
  [GTM_CLICK_TRACKING_PROP_NAME]: JSON.stringify(createTasteProfileEvent(eventAction, eventLabel, nonInteraction))
})

export const createTasteProfileFilterEvent = (filter, value = '') => Object.assign({}, TASTE_PROFILE_GA_FILTER_EVENT, {
  eventAction: filter,
  eventLabel: value
})

export const trackTasteProfileFilterEvent = (eventAction, eventLabel = '', nonInteraction = false) => ({
  [GTM_CLICK_TRACKING_PROP_NAME]: JSON.stringify(createTasteProfileEvent(eventAction, eventLabel, nonInteraction))
})

export const getCategoryBreadcrumb = (categories) => { // eslint-disable-line arrow-body-style
  // convert a product category string from GraphQL API
  // e.g. "wijn/rode-wijn/stevig-rood" -> "Wijn / Rode wijn / Stevig rood"
  // so it's human readable in GTM
  return categories
    .split('/')
    .map((category) => upperFirst(category.replace('-', ' ')))
    .join(' / ')
}

export const getProductObject = (name, id, price, category) => ({
  name,
  id: id.toString(),
  price: price.retail,
  category: getCategoryBreadcrumb(category[0])
})

export const getPrice = (unitPriceStr, quantity) => {
  if (quantity > 1) {
    return (parseFloat(unitPriceStr) * quantity).toPrecision(3)
  }
  return unitPriceStr
}

export const createProductImpressionEvent = (name, id, price, category) => Object.assign(
  getProductObject(name, id, price, category),
  {
    list: window.location.pathname
  }
)

export const trackProductImpression = (name, id, price, category) => ({
  [GTM_IMPRESSION_TRACKING_PROP_NAME]: JSON.stringify(createProductImpressionEvent(name, id, price, category))
})

export const createTrackingStructure = () => JSON.stringify({
  event: 'impressions',
  ecommerce: {
    impressions: []
  }
})

export const createProductClickEvent = (name, id, price, category, list) => ({
  event: 'productClick',
  ecommerce: {
    click: {
      actionField: {
        list
      },
      products: [
        getProductObject(name, id, price, category)
      ]
    }
  }
})

export const trackProductClick = (name, id, price, category, list) => ({
  [GTM_CLICK_TRACKING_PROP_NAME]: JSON.stringify(createProductClickEvent(name, id, price, category, list))
})

export const createAddToCartEvent = (name, id, price, category, quantity, dimension) => {
  const product = {
    ...getProductObject(name, id, price, category),
    quantity: quantity.toString(),
    dimension20: dimension,
    metric7: getPrice(price.retail, quantity)
  }

  return {
    event: 'addToCart',
    ecommerce: {
      currencyCode: 'EUR',
      add: {
        actionField: {
          list: window.location.pathname
        },
        products: [
          product
        ]
      }
    }
  }
}

export const trackAddToCartEvent = (name, id, price, category, quantity, dimension) => ({
  [GTM_CLICK_TRACKING_PROP_NAME]: JSON.stringify(createAddToCartEvent(name, id, price, category, quantity, dimension))
})
